/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupContractMandatItemDto } from './GroupContractMandatItemDto';
import {
    GroupContractMandatItemDtoFromJSON,
    GroupContractMandatItemDtoFromJSONTyped,
    GroupContractMandatItemDtoToJSON,
    GroupContractMandatItemDtoToJSONTyped,
} from './GroupContractMandatItemDto';
import type { GroupContractBankAccountDto } from './GroupContractBankAccountDto';
import {
    GroupContractBankAccountDtoFromJSON,
    GroupContractBankAccountDtoFromJSONTyped,
    GroupContractBankAccountDtoToJSON,
    GroupContractBankAccountDtoToJSONTyped,
} from './GroupContractBankAccountDto';

/**
 * 
 * @export
 * @interface GetGroupContractMandatsResponse
 */
export interface GetGroupContractMandatsResponse {
    /**
     * True if at least 1 mandate is signed OR contract is finalized.
     * @type {boolean}
     * @memberof GetGroupContractMandatsResponse
     */
    isLocked: boolean;
    /**
     * Cadre-only flag — each aliment pays its own debit.
     * @type {boolean}
     * @memberof GetGroupContractMandatsResponse
     */
    paymentByAliments: boolean;
    /**
     * Bank account currently used (debtor) — inferred from mandates' IbanDebiteur.
     * @type {string}
     * @memberof GetGroupContractMandatsResponse
     */
    selectedBankAccountId?: string | null;
    /**
     * 
     * @type {Array<GroupContractBankAccountDto>}
     * @memberof GetGroupContractMandatsResponse
     */
    bankAccounts: Array<GroupContractBankAccountDto>;
    /**
     * Unique mandates of the contract (deduplicated by creditor IBAN).
     * @type {Array<GroupContractMandatItemDto>}
     * @memberof GetGroupContractMandatsResponse
     */
    mandats: Array<GroupContractMandatItemDto>;
}

/**
 * Check if a given object implements the GetGroupContractMandatsResponse interface.
 */
export function instanceOfGetGroupContractMandatsResponse(value: object): value is GetGroupContractMandatsResponse {
    if (!('isLocked' in value) || value['isLocked'] === undefined) return false;
    if (!('paymentByAliments' in value) || value['paymentByAliments'] === undefined) return false;
    if (!('bankAccounts' in value) || value['bankAccounts'] === undefined) return false;
    if (!('mandats' in value) || value['mandats'] === undefined) return false;
    return true;
}

export function GetGroupContractMandatsResponseFromJSON(json: any): GetGroupContractMandatsResponse {
    return GetGroupContractMandatsResponseFromJSONTyped(json, false);
}

export function GetGroupContractMandatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroupContractMandatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isLocked': json['isLocked'],
        'paymentByAliments': json['paymentByAliments'],
        'selectedBankAccountId': json['selectedBankAccountId'] == null ? undefined : json['selectedBankAccountId'],
        'bankAccounts': ((json['bankAccounts'] as Array<any>).map(GroupContractBankAccountDtoFromJSON)),
        'mandats': ((json['mandats'] as Array<any>).map(GroupContractMandatItemDtoFromJSON)),
    };
}

export function GetGroupContractMandatsResponseToJSON(json: any): GetGroupContractMandatsResponse {
    return GetGroupContractMandatsResponseToJSONTyped(json, false);
}

export function GetGroupContractMandatsResponseToJSONTyped(value?: GetGroupContractMandatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isLocked': value['isLocked'],
        'paymentByAliments': value['paymentByAliments'],
        'selectedBankAccountId': value['selectedBankAccountId'],
        'bankAccounts': ((value['bankAccounts'] as Array<any>).map(GroupContractBankAccountDtoToJSON)),
        'mandats': ((value['mandats'] as Array<any>).map(GroupContractMandatItemDtoToJSON)),
    };
}

